import { Variant } from "../../../../Interfaces/Product";
import { IConfiguratorUpdater } from "../types";
import LoaderOverlay from "../../../LoaderOverlay";
import { SECTIONS } from "../configuration";

export class Sections implements IConfiguratorUpdater {
    private variant: Variant;
    private parser: DOMParser = new DOMParser();
    loadOverlay: LoaderOverlay = new LoaderOverlay();

    constructor(private node: HTMLElement) {
        this.node = node;
    }

    /**
     * retrieve and exchange section html
     * @param v
     */
    public async update(v: Variant) {
        try {
            this.loadOverlay.render();
            this.variant = v;
            const result = await fetch(this.sectionsUrl);
            Object.values(SECTIONS).forEach((section) => {
                if (section.hooks?.before) {
                    section.hooks.before();
                }
            });
            const data = await result.json();
            Object.values(SECTIONS).forEach((section) => {
                if (data[section.section]) {
                    const newSection = this.parser.parseFromString(data[section.section], "text/html");
                    const oldSection = document.querySelector(section.selectorOld);
                    if (oldSection) {
                        if (section.replaceMode === "all") {
                            oldSection.parentElement.replaceChild(
                                newSection.querySelector(".shopify-section").firstChild,
                                oldSection
                            );
                        } else if (section.replaceMode === "childNodes") {
                            oldSection.innerHTML = newSection.querySelector(section.selectorNew).innerHTML;
                        }
                    }
                    if (section.hooks?.after) {
                        section.hooks.after();
                    }
                }
            });
        } catch (error) {
            console.error(error);
        } finally {
            this.loadOverlay.destroy();
        }
    }

    /**
     * obtain section params
     */
    private static get sectionParams(): string {
        return Object.values(SECTIONS)
            .reduce((acc, cur) => {
                acc.push(cur.section);
                return acc;
            }, [])
            .join(",");
    }

    /**
     * obtain section URL
     */
    private get sectionsUrl(): string {
        const params = [`variant=${this.variant.id}`, `sections=${Sections.sectionParams}`].join("&");

        return `${location.pathname}?${params}`;
    }
}
